import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { styled as materialStyled } from "@mui/material/styles";
import { Radio, RadioGroup, FormControl, FormControlLabel } from "@mui/material/";

import { H2 } from "commons";

import { deliveryOptionProp } from "../../../constants/propTypes";

export function OptionList({ documentType, allDeliveryOptions = [], selectedOption, onChange }) {
    return selectedOption ? (
        <Container>
            <H2 margin="0 0 1rem 0">{documentType}</H2>
            <StyledFormControl>
                <StyledGroup
                    aria-label="document delivery options"
                    value={selectedOption}
                    onChange={onChange}
                    row
                >
                    {allDeliveryOptions.map(option => (
                        <StyledLabel
                            key={option.codeDescription}
                            value={option.codeCode}
                            control={<Radio data-testid="delivery-option" />}
                            label={option.codeDescription}
                        />
                    ))}
                </StyledGroup>
            </StyledFormControl>
        </Container>
    ) : null;
}

const Container = styled.div`
    max-width: 100%;
`;

const StyledGroup = styled(RadioGroup)({
    maxWidth: "600px"
});

const StyledLabel = materialStyled(FormControlLabel)({
    flexGrow: 1,
    flexBasis: "300px",
    margin: 0
});

const StyledFormControl = materialStyled(FormControl)({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
});

OptionList.propTypes = {
    documentType: PropTypes.string,
    allDeliveryOptions: PropTypes.arrayOf(deliveryOptionProp),
    selectedOption: PropTypes.string,
    onChange: PropTypes.func
};
